module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rd_station_crm"
    }
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(0), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.rdStation')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.rdStation')))])])])])]), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-5",
    class: {
      'has-error': _vm.errors.has('rd_station_crm_api_key')
    }
  }, [_c('label', {
    attrs: {
      "for": "rd_station_crm_api_key"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.apiKey')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rd_station_crm_api_key),
      expression: "rd_station_crm_api_key"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "rd_station_crm_api_key",
      "type": "text",
      "placeholder": _vm.$t('integrations.placeholder.apiKey')
    },
    domProps: {
      "value": (_vm.rd_station_crm_api_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rd_station_crm_api_key = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rd_station_crm_api_key')),
      expression: "errors.has('rd_station_crm_api_key')"
    }],
    key: "rd_station_crm_api_key",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('rd_station_crm_api_key')))])])], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('div', {
    staticClass: "checkbox-inline contact-list-item-checkbox-item",
    on: {
      "click": function($event) {
        return _vm.toggleCopySettings()
      }
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_vm._v(" ")]), _c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.copy_settings
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.copySettings')))])])]), (_vm.copy_settings) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_vm._v(" ")]), _c('div', {
    staticClass: "col-md-10 padding-none"
  }, [_c('dropdown-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.users_options_rd
    },
    model: {
      value: (_vm.user_rd_setting),
      callback: function($$v) {
        _vm.user_rd_setting = $$v
      },
      expression: "user_rd_setting"
    }
  })], 1), _c('div', {
    staticClass: "com-md-2"
  }, [_c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.copy')))])])]) : _vm._e()]), _c('trigger-stages', {
    attrs: {
      "integration": "rd station crm",
      "settings": _vm.rd_station_crm_setting.triggers
    },
    on: {
      "selected-stages": _vm.setStagesRDStationCRM
    }
  }), _c('properties-matching', {
    attrs: {
      "properties_matching": _vm.rd_station_crm_setting.properties_matching,
      "integration_name": "rd station crm",
      "api_fields": _vm.api_fields
    },
    on: {
      "matching-updated": _vm.matchingUpdated
    }
  }), _c('stages-matching', {
    attrs: {
      "stages_matching": _vm.rd_station_crm_setting.stages_matching,
      "integration_name": "rd station crm",
      "integration_no_stages_api": !_vm.has_stages_api,
      "integration_stages": _vm.integration_stages,
      "pipelines": _vm.pipelines,
      "pipeline_id": _vm.selected_pipeline
    },
    on: {
      "matching-updated": _vm.matchingStagesUpdated,
      "users-update": _vm.updateUsers,
      "update-stages": _vm.changePipeline
    }
  }), _c('hr'), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), (_vm.current_user.rd_station_crm_api_key) ? _c('button', {
    staticClass: "pull-right btn btn-danger",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": _vm.removeRDStationCRMApiKey
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.disconnect')))]) : _vm._e(), _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/rdstationcrm.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d07467e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/integrations/rd_station_crm.vue
// module id = 1060
// module chunks = 1